import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { Http } from "@status/codes";
import { FIELD_WITHOUT_DATA } from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { SessionTemplateService } from "@/modules/SessionTemplate/services/SessionTemplateService";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";

export class SessionsPropertiesValues extends ListOfPropertiesValues {
  serviceTemplate = this.getServiceTemplates;
  sessionTemplate = this.getSessionTemplates;
  user = this.getUsers;
  attendedBy = this.getUsers;
  sectionKey = this.getSections;
  groupKey = this.getGroups;
  lastDocId = "";
  keyword = "";
  indexSectionOfDashboard = 0;
  indexCollection = 0;

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string,
    lastDocId?: string
  ) {
    this.lastDocId = lastDocId || "";
    if (keyWord) {
      return (await this[field as keyof SessionsPropertiesValues](
        keyWord
      )) as DynamicSelectData[];
    }

    if (this.keyword) {
      this.keyword = "";
    }

    if (idList) {
      return this.getList(idList);
    }

    return await this[field as keyof SessionsPropertiesValues]();
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }

  async getServiceTemplates() {
    return await this.getServiceTemplatesCommonFunction();
  }

  async getSessionTemplates() {
    try {
      const sessionTemplateService = new SessionTemplateService();
      const response = await sessionTemplateService.getAllActiveSessionTemplates();
      if (response.code === Http.Found && response.data) {
        const sessionTemplatesList: DynamicSelectData[] = [];
        response.data.forEach(({ id, name }) => {
          sessionTemplatesList.push({
            id: id as string,
            name: name
          });
        });
        sessionTemplatesList.push(FIELD_WITHOUT_DATA);
        return { data: sessionTemplatesList };
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUsers(name?: string) {
    return await this.getUserByQuery(this.setFilters.bind(this), name);
  }

  setFilters(keyLastRef: string, name?: string) {
    const filterQuery: any = {
      state: GENERAL_RULES_CONSTANTS.ACTIVO
    };

    if (name && this.keyword !== name) {
      this.keyword = name;
      filterQuery.name = name;
      delete filterQuery[keyLastRef];
      return filterQuery;
    }

    if (name) {
      filterQuery.name = name;
      if (this.keyword !== name) {
        this.keyword = name;
      }
      return filterQuery;
    }

    return filterQuery;
  }

  async addSectionsOrGroups(valueOfField: { id: string; name: string }[]) {
    return await this.addSectionsOrGroupsCommonFunction(
      valueOfField,
      this.indexSectionOfDashboard
    );
  }

  getSections() {
    return this.getSectionsCommonFunctions(this.indexSectionOfDashboard);
  }
  getGroups() {
    return this.getGroupsCommonFunctions(this.indexSectionOfDashboard);
  }
}
